import { render, staticRenderFns } from "./SvgRenderer.vue?vue&type=template&id=0abdc940&"
import script from "./SvgRenderer.vue?vue&type=script&lang=js&"
export * from "./SvgRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports